

const APP_PREFIX = process.env.PUBLIC_URL?.replace("/", "") || "app"
const KEY_PREFIX = "turvallisuus-sovellukset-app";

const makeStorageKey = (...args: string[]) => [KEY_PREFIX, APP_PREFIX, ...args].join(":");

export const AUTH_COOKIE = makeStorageKey("auth");
export const RETURN_HREF_COOKIE = makeStorageKey("returnHref");
export const RDR_COOKIE = makeStorageKey("rdr");

export const PREV_LOCATION = makeStorageKey("PrevLocation", "path");

